export default __webpack_public_path__ + "static/media/item-add.cbb64cc0.svg";